import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Alert,
  ButtonDropdown,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Label,
} from 'reactstrap';
import * as BoxesActions from '../../actions/EpikBoxes';
import { editNumberFieldChange, getForwardUri } from '../../actions/Numbers';
import getObiData from '../../containers/epikBoxes/helpers';

const EditNumberModalEpikBox = ({
  company,
  getBoxes,
  boxes,
  getForwardUri,
  forwardUri,
  editNumberFieldChange,
  number,
  getEpikBoxData,
  boxDetails,
}) => {
  const [box, setBox] = useState(false);
  const [port, setPort] = useState(false);
  const [boxName, setBoxName] = useState({ name: 'Choose Edge Device', id: '' });
  const [boxData, setBoxData] = useState({});
  const [portName, setPortName] = useState('Choose Port');
  const token = localStorage.getItem('jwtToken') || null;

  useEffect(() => {
    (async function() {
      let status = 'all';
      await getBoxes(token, company, status, undefined, 'yes');
    })();
  }, []);

  useEffect(() => {
    setBoxData(boxDetails);
  }, [boxDetails]);

  useEffect(() => {
    (async function() {
      if (boxName.name !== 'Choose Edge Device' && portName !== 'Choose Port') {
        const portSelected = portName.split(' ');
        const obiNumber = getObiData(portName, boxData, 'obiNumber');
        await editNumberFieldChange('obiNumber', obiNumber);
        await editNumberFieldChange('port', parseInt(portSelected[1]));
        await getForwardUri(token, obiNumber, portName.toLowerCase(), 'forwardUri');
      }
    })();
  }, [portName]);

  useEffect(() => {
    if (forwardUri.length !== 0) {
      editNumberFieldChange('forwardUris', [...number.forwardUris, forwardUri]);
    }
  }, [forwardUri]);

  const toggleBox = () => setBox(!box);
  const togglePort = () => setPort(!port);

  const sortPort = () => {
    let arrPort = [];
    if (boxDetails.length !== 0) {
      arrPort = boxDetails.Obis.map(item => [
        ...arrPort,
        item.port1.boxPortNumber,
        item.port2.boxPortNumber,
      ]);
    }
    const newArray = arrPort.reduce((acc, current) => {
      return [...acc, ...current];
    }, []);
    return newArray.sort() || [];
  };

  return (
    <div className="numbers-container">
      <FormGroup row>
        <Label for="number" sm={4}>
          Choose Edge Devices
        </Label>
        <Col sm={8}>
          <ButtonDropdown isOpen={box} toggle={toggleBox} style={{ width: '100%' }}>
            <DropdownToggle
              style={{ borderRight: 'none', textOverflow: 'ellipsis', overflow: 'hidden' }}
              caret
            >
              {boxName.name}
            </DropdownToggle>
            <DropdownMenu
              style={{ maxHeight: '300px', overflow: 'auto', borderRight: 'none', width: '100%' }}
            >
              {boxes.length !== 0 ? (
                boxes.map(item => (
                  <DropdownItem
                    style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}
                    key={item._id}
                    onClick={async () => {
                      await getEpikBoxData(token, item._id);
                      setBoxName({ name: item.boxName, id: item._id });
                    }}
                  >
                    {item.boxName}
                  </DropdownItem>
                ))
              ) : (
                <Alert colSpan={4} color="info" className="price-not-found-alert">
                  No boxes
                </Alert>
              )}
            </DropdownMenu>
          </ButtonDropdown>
        </Col>
      </FormGroup>
      {boxName.id !== '' && (
        <>
          <FormGroup row>
            <Label for="number" sm={4}>
              Choose Port`s
            </Label>
            <Col sm={8}>
              <ButtonDropdown isOpen={port} toggle={togglePort}>
                <DropdownToggle style={{ borderRight: 'none' }} caret>
                  {portName}
                </DropdownToggle>
                <DropdownMenu style={{ maxHeight: '300px', overflow: 'auto' }}>
                  {sortPort().length !== 0 ? (
                    sortPort().map((port, i) => (
                      <div key={i}>
                        <DropdownItem onClick={() => setPortName(port ? port : `port ${i + 1}`)}>
                          {port ? port : `port ${i + 1}`}
                        </DropdownItem>
                      </div>
                    ))
                  ) : (
                    <div>
                      <Alert colSpan={4} color="info" className="price-not-found-alert">
                        Choose another box
                      </Alert>
                    </div>
                  )}
                </DropdownMenu>
              </ButtonDropdown>
            </Col>
          </FormGroup>
          {portName !== 'Choose Port' && (
            <>
              <FormGroup row>
                <Label for="number" sm={4}>
                  ForwardUri
                </Label>
                <Col sm={8} style={{ display: 'flex', alignItems: 'center' }}>
                  <span>{forwardUri}</span>
                </Col>
              </FormGroup>
            </>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  number: state.UIState.numbers.editNumber,
  company: state.UIState.numbers.editNumber.company,
  forwardUri: state.UIState.numbers.addForwardUri,
  boxes: state.AppState.boxes,
  boxDetails: state.AppState.boxDetails.box,
});

const mapDispatchToProps = dispatch => ({
  getBoxes: (token, companyId, status, unmonitored, disablePagination) =>
    dispatch(
      BoxesActions.getEpikBoxesData(token, companyId, status, unmonitored, disablePagination),
    ),
  getForwardUri: (token, obiNumber, portName, name) =>
    dispatch(getForwardUri(token, obiNumber, portName, name)),
  editNumberFieldChange: (name, value) => dispatch(editNumberFieldChange(name, value)),
  getEpikBoxData: (token, boxId) => dispatch(BoxesActions.getEpikBoxData(token, boxId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditNumberModalEpikBox);
